import React, { useEffect, useState } from 'react'
import FormDireccion from '../FormDireccion'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCustomerById,
  searchInfoAddressId,
} from 'redux/actions/clientsActions'
import { customerTypeId } from 'Utils/constants'
import { AddressOption } from './components/AddressOption'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { useOrderAllocation } from 'Hooks/useOrderAllocation'
import MiniLoading from 'Components/MiniLoading'
import { validatorIsCountedCustomer } from 'Utils/functions'

const Direcciones = ({
  setDireccion,
  onCloseMetodoEntrega,
  insideForm,
  selectedAddress,
  validateOnSuccessCallAddress,
  autoClose = true,
  setPromisedDate,
  companyCode,
  products,
  method,
  setMinDateOA,
  oaLoading,
  setOaLoading,
  isEditMode = false,
  onSelectDirection = () => {},
  customerAddress,
}) => {
  const dispatch = useDispatch()
  const clienteId = useSelector(
    state => state?.cotizacion?.QuoteHeader?.CustomerId
  )

  const useSelectorQuoteObject = useSelector(state => state?.cotizacion)

  const isCountedCustomer = validatorIsCountedCustomer(
    useSelectorQuoteObject?.QuoteHeader
  )

  const [allClienteAddresses, setClienteAddresses] = useState([])
  const [isErrorAddressModal, setIsErrorAddressModal] = useState(false)
  const [addressInfo, setAddressInfo] = useState(selectedAddress)
  const [isloadingAddress, setIsloadingAddress] = useState(false)
  const [messageAddressModal, setMessageAddressModal] = useState({
    message: '',
    status: '',
  })

  // Refs para rastrear si ya se ha cargado
  const isFirstLoadRef = React.useRef(true)
  const loadedClientIdRef = React.useRef(null)
  const loadedAddressIdRef = React.useRef(null)

  const clienteAddresses = allClienteAddresses?.filter(item => item.AddressInfo)
  const quote = useSelectorQuoteObject?.QuoteHeader

  const {
    oaLoading: hookOaLoading,
    oaError: hookOaError,
    executeOADelivery,
    getMinDateFromOA,
    setOaError,
  } = useOrderAllocation({
    documentId: quote?.QuoteHeaderId,
    companyCode,
    products,
  })

  React.useEffect(() => {
    if (setOaLoading) setOaLoading(hookOaLoading)
  }, [hookOaLoading, setOaLoading])

  const fetchCustomer = async (currentCustomerId, address) => {
    setIsloadingAddress(true)

    if (address) {
      setClienteAddresses(address)
    } else {
      const customerInfo = await dispatch(getCustomerById(currentCustomerId))
      const newAddress =
        customerInfo?.CustomerType?.CustomerTypeId === customerTypeId.natural
          ? customerInfo?.AddressList?.filter(address => address?.AddressInfo)
          : customerInfo?.AdministrativeStoreInfo?.AddressList?.filter(
              address => address?.AddressInfo
            )

      setClienteAddresses(newAddress)
    }

    setIsloadingAddress(false)
  }

  useEffect(async () => {
    const addressId =
      quote?.AddressId ||
      quote?.Address_AddressId ||
      quote?.QuoteAddressIdCounted

    let allData

    // Solo mostrar loading en la primera carga
    const shouldShowLoading = isFirstLoadRef.current

    if (!isCountedCustomer) {
      // Si el clienteId ha cambiado, cargar las direcciones del cliente
      if (clienteId && loadedClientIdRef.current !== clienteId) {
        if (shouldShowLoading) {
          setIsloadingAddress(true)
        }
        await fetchCustomer(clienteId, customerAddress)
        loadedClientIdRef.current = clienteId
      }
    } else if (addressId || allData?.QuoteAddressId) {
      // Si el addressId ha cambiado, cargar la información de la dirección
      if (loadedAddressIdRef.current !== addressId) {
        if (shouldShowLoading) {
          setIsloadingAddress(true)
        }
        const newAddressId = addressId || allData?.QuoteAddressId
        const responseAddressInfo = await dispatch(
          searchInfoAddressId(newAddressId)
        )
        const dataAddress = responseAddressInfo?.[0]
        setAddressInfo(dataAddress)
        const newAddress = [
          {
            AddressInfo: dataAddress,
          },
        ]
        setClienteAddresses(newAddress)
        setIsloadingAddress(false)
        loadedAddressIdRef.current = addressId

        if (dataAddress && setPromisedDate && companyCode && products?.length) {
          const oaResponse = await executeOADelivery({
            AddressInfo: dataAddress,
          })
          if (oaResponse) {
            const minDate = getMinDateFromOA(oaResponse)
            if (minDate) {
              setPromisedDate(new Date(minDate).toISOString())
              if (setMinDateOA) {
                setMinDateOA(new Date(minDate).toISOString())
              }
            }
          }
        }
      }
    }

    setMostrarFormDireccion(false)

    // Marcar que ya no es la primera carga
    isFirstLoadRef.current = false
  }, [
    clienteId,
    quote?.AddressId,
    quote?.Address_AddressId,
    quote?.QuoteAddressIdCounted,
    isCountedCustomer,
  ])

  const [optionSelect, setOptionSelect] = useState(addressInfo || null)
  // MOSTRAR FORMULARIO DE DIRECCIONs
  const [mostrarFormDireccion, setMostrarFormDireccion] = useState(false)
  const [addressDetails, setAddressDetails] = useState(null)
  const [hasAutoSelected, setHasAutoSelected] = useState(false)

  useEffect(() => {
    if (isEditMode && selectedAddress && !hasAutoSelected) {
      // Si el objeto recibido NO es una dirección, buscar la dirección real
      let addressToSelect = selectedAddress
      if (!selectedAddress.AddressInfo && selectedAddress.Address_AddressId) {
        const found = clienteAddresses.find(
          a => a.AddressInfo?.AddressId === selectedAddress.Address_AddressId
        )
        if (found) {
          addressToSelect = found
        }
      }
      if (addressToSelect.AddressInfo) {
        selectAddress(addressToSelect, false) // NO forzar, solo validar
        setHasAutoSelected(true)
      }
    }
    // eslint-disable-next-line
  }, [isEditMode, selectedAddress, clienteAddresses])

  const selectAddress = async (address, forceUpdateDate = false) => {
    setOptionSelect(address)
    if (address) {
      onSelectDirection(address)
      setDireccion(true)

      if (
        method === 'domicilio' &&
        setPromisedDate &&
        companyCode &&
        products?.length
      ) {
        const shouldExecuteOA = isEditMode || true

        if (shouldExecuteOA) {
          const oaResponse = await executeOADelivery(address)
          if (oaResponse) {
            const minDate = getMinDateFromOA(oaResponse)
            if (minDate) {
              if (forceUpdateDate) {
                setPromisedDate(new Date(minDate).toISOString())
              } else {
                const precargada =
                  (selectedAddress && selectedAddress.PromisedDate) ||
                  address?.PromisedDate
                if (precargada) {
                  const precargadaDate = new Date(precargada)
                  const minDateObj = new Date(minDate)
                  if (precargadaDate < minDateObj) {
                    setPromisedDate(new Date(minDate).toISOString())
                  } else {
                    setPromisedDate(new Date(precargada).toISOString())
                  }
                } else {
                  setPromisedDate(new Date(minDate).toISOString())
                }
              }
              if (setMinDateOA) {
                setMinDateOA(new Date(minDate).toISOString())
              }
            }
          }
        }
      }
      if (autoClose) onCloseMetodoEntrega(false)
    }
  }

  return (
    <>
      {isErrorAddressModal && (
        <ModalAlertGeneric
          isError={isErrorAddressModal}
          setIsError={setIsErrorAddressModal}
          messageSettings={messageAddressModal}
          setMessageSettings={setMessageAddressModal}
        />
      )}
      {hookOaError && (
        <ModalAlertGeneric
          isError={true}
          setIsError={setOaError}
          data-testid="modal-error-generic"
          messageSettings={{ message: hookOaError, status: 'error' }}
          setMessageSettings={() => {}}
        />
      )}
      {mostrarFormDireccion || !!addressDetails ? (
        <FormDireccion
          setSelectedAddress={onSelectDirection}
          setDireccion={setDireccion}
          handleMetodoEntrega={async () => {
            if (addressDetails) {
              if (!isCountedCustomer) await fetchCustomer(clienteId)

              setAddressDetails(null)
            }
          }}
          defaultValues={addressDetails}
          onClose={() => setAddressDetails(null)}
          showHeader={false}
          updateCotizationAddress
          setIsErrorAddressModal={setIsErrorAddressModal}
          setMessageAddressModal={setMessageAddressModal}
        />
      ) : (
        <form
          className="content-domicilio"
          data-testid="form-address-selection"
          style={{ padding: insideForm && 0 }}>
          {isloadingAddress ? (
            <MiniLoading noMargin={true} />
          ) : (
            <>
              <p className="field-label">Seleccione una dirección</p>
              <ul
                className="address-options"
                data-testid="ul-customer-addresses">
                {clienteAddresses &&
                  clienteAddresses.map((currAddress, index) => {
                    return (
                      <AddressOption
                        key={index}
                        loader={isloadingAddress}
                        address={currAddress}
                        selectAddress={selectAddress}
                        optionSelected={optionSelect}
                        clienteAddresses={clienteAddresses}
                        showEditAddress={() =>
                          setAddressDetails(currAddress?.AddressInfo)
                        }
                      />
                    )
                  })}
                {isCountedCustomer && clienteAddresses?.length ? null : (
                  <li
                    className="domicilio-option add-domicilio"
                    data-testid="btn-add-new-address"
                    onClick={() =>
                      setMostrarFormDireccion(!mostrarFormDireccion)
                    }>
                    <label htmlFor="">Agregar nueva dirección</label>
                    <div className="add-domicilio">+</div>
                  </li>
                )}
              </ul>
            </>
          )}
        </form>
      )}
    </>
  )
}

export default Direcciones
